/*
 * @Author: ymk
 * @Date: 2020-07-23 09:52:48
 * @LastEditors: ymk
 * @LastEditTime: 2020-07-24 15:21:52
 * @FilePath: \car-demo\src\main.js
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from './utils/axios'
import FixedTool from './components/FixedTool.vue'

Vue.component('FixedTool', FixedTool);

// 引入NutUI
import './plugin';
import cache from "./utils/cache";
Vue.prototype.$ajax = axios;

Vue.config.productionTip = false
store.dispatch('getPageConfig');
let beforeEachFlag = false ;
router.beforeEach((to,from,next)=>{
  if(to.name !== 'init'){
    if(beforeEachFlag===false){
      if(!cache.get('__platform_id__') || cache.get('__platform_id__') == 'undefined' || cache.get('__platform_id__') == undefined){
        beforeEachFlag = true ;
        setTimeout(()=>{
          beforeEachFlag = false;
        },800);
        //var call_path;
        var is_param = false;
        var is_query = false;
        if(to.params){      //项目里面基本不用params传参
          is_param = JSON.stringify(to.params);
        }
        if(to.query){
          is_query = JSON.stringify(to.query);
        }
        router.push({name:'init',query:{name:to.name,is_param:is_param,is_query:is_query}});return ;
      }
    }
  }
  store.commit('setPageShareConfig',to.path);
  next();
})

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
